import React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import NavResponsive from "../../Components/FormElements/NavResponsive";
import IconBack from "../../Resources/svg/Icons/IconBack";
import FormTitle from "../../Components/FormElements/FormTitle";
import Footer from "../../Components/Footer";
import BreadCrumbs from "../BreadCrumbs";

export const ModalitiesPageRV = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const data = location.state;

  const { nroOperacion } = data;

  const navigationPrev = () => {
    history.goBack();
  };

  return (
    <>
      <div className="wrap">
        <NavResponsive
          position={0}
          title={"Modalidad de solicitud"}
          hidden={true}
          justBack={true}
        />
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Cotizaciones" }, { link: "Modalidades" }]}
            />
            <div className="back-responsive">
              <div className="back-responsive__box">
                <IconBack
                  className="nav-case__back"
                  onClick={() => history.push(-1)}
                />
                <div className="back-responsive__text">Volver</div>
              </div>
            </div>
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={navigationPrev} />
              <div className="nav-case__title">{"Modalidades"}</div>
            </div>
          </div>
          <div className="form-register approve-quote">
            <FormTitle title={`Modalidades de Solicitud N° ${nroOperacion}`} />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};
